import * as React from 'react';

export default function useAdbarHeight(): void {
    const [elementHeight, setElementHeight] = React.useState(0);
    const styleRef = React.useRef<HTMLStyleElement | null>(null);

    React.useEffect(() => {
        const style = document.createElement('style');
        const styleElement = document.head.appendChild(style);
        styleRef.current = style;

        const checkElement = () => {
            // set the state to bar height if unbounce is using a fixed bar
            // update variable to 0 if the bar is closed or there is no bar
            const unbounceFixedBar =
                document.querySelector('.ub-emb-bar-frame');
            setElementHeight(unbounceFixedBar?.clientHeight ?? 0);
        };

        // set initial height
        checkElement();

        const observer = new MutationObserver(checkElement);
        observer.observe(document.body, { childList: true, subtree: true });

        return function cleanup() {
            observer.disconnect();
            if (styleElement.parentNode) {
                styleElement.parentNode.removeChild(styleElement);
                styleRef.current?.remove();
            }
        };
    }, []);

    React.useEffect(() => {
        // whenever ad bar element height changes set --adbar-height in style element
        if (styleRef.current) {
            styleRef.current.textContent = `
                body {
                    --adbar-height: ${elementHeight}px;
                }
            `;
        }
    }, [elementHeight]);
}
